import { render, staticRenderFns } from "./GdprSettings.vue?vue&type=template&id=dfe78a3a"
import script from "./GdprSettings.vue?vue&type=script&lang=js"
export * from "./GdprSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports